import { useTranslation } from 'react-i18next';
import { RadarIcon } from 'lucide-react';
import { Button } from '@noor/ui';
import { useModalStore } from '@noor/lib';
import { Can } from '@/entities/access';

/** Opens the courier-offers visualization for an order. */
export function OrderOffersButton({ orderId }: { orderId: string | number }) {
  const { t } = useTranslation('orders');
  const openModal = useModalStore((s) => s.openModal);
  return (
    <Can permission="orders.detail.view">
      <Button
        variant="soft"
        size="modal"
        shape="rounded"
        onClick={() => openModal('order-offers', { orderId })}
      >
        <RadarIcon className="size-4" />
        {t('offers.open')}
      </Button>
    </Can>
  );
}
